<template>

        <portal to="modal">    
      <AnonymousComplaintModal :content="content" /> 
        </portal>
 
</template>

<script>
import AnonymousComplaintModal from '@/components/modals/AnonymousComplaintModal';

export default {
    props: ['contentData'], components: { AnonymousComplaintModal }, 
    computed: {
        content(){
            return _.get(this.contentData, 'data.list[0].content.tabs[0]');
        }
    },
    mounted(){
        console.log(this.content)
    },
}
</script>

<style>

</style>